import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  /** Действие справа от заголовка */
  action?: ReactNode;
  /** Без внутренних отступов — для списков `ListRow` внутри */
  flush?: boolean;
  /** Выделенная карточка (ближайший сбор на главном экране) */
  accent?: boolean;
  children: ReactNode;
}

/** Поверхность на фоне: секции экрана, ближайший сбор, состав. */
export function Card({ title, action, flush, accent, className, children, ...rest }: CardProps) {
  return (
    <section
      className={cn(
        'rounded-card bg-surface overflow-hidden',
        accent && 'ring-accent/60 ring-1',
        className,
      )}
      {...rest}
    >
      {title || action ? (
        <header className="flex items-center justify-between gap-3 px-4 pt-4 pb-2">
          {title ? (
            <h2 className="text-muted text-xs font-semibold tracking-wide uppercase">{title}</h2>
          ) : (
            <span />
          )}
          {action}
        </header>
      ) : null}
      <div className={cn(!flush && 'px-4 pb-4', !flush && !title && 'pt-4')}>{children}</div>
    </section>
  );
}
